jQuery(document).ready(function($) {

  $(document).foundation()

  // mobile menu toggle
  $('.mobile-menu-toggle').on('click', function() {
    $('body').toggleClass('mobile-menu--is-showing')
  })

  // main menu lab-title-menu add arrows
  $('.lab-title-menu ul').first().find('li').each(function () {
    if ($(this).find('ul').length > 0) {
      $(this).addClass('has-dropdown')
    }
  })

  // mobile menu
  $('.mobile-menu ul').first().find('li').each(function () {
    if ($(this).find('ul').length > 0) {
      $(this).addClass('has-dropdown')
    }
  })

  // remove main and mobile menu dropdowns
  if ($('.lab-title-menu-settings').data('disable-dropdown-menus') == 1) {
    $('.lab-title-menu li.has-dropdown').find('ul').remove()
    $('.lab-title-menu li').removeClass('has-dropdown')
    $('.mobile-menu li.has-dropdown').find('ul').remove()
    $('.mobile-menu li').removeClass('has-dropdown')
  }

  // remove main and mobile menu dropdowns for certain pages
  if ($('.lab-title-menu-settings').find('span').length > 0) {
    var nids = []
    $('.lab-title-menu-settings').find('span').each(function() {
      nids.push($(this).data('drupal-link-system-path'))
    })
    $('.lab-title-menu li.has-dropdown, .mobile-menu li.has-dropdown').each(function() {
      var $li = $(this)
      var $a = $li.find('a').first()
      if (nids.includes($a.data('drupal-link-system-path')) == false) {
        $li.find('ul').remove()
        $li.removeClass('has-dropdown')
      }
    })
  }

  // remove main and mobile menu links for profile pages not set to link
  $('[data-remove-from-dropdown-menu]').each(function() {
    $('.lab-title-menu a[data-drupal-link-system-path="' + $(this).data('remove-from-dropdown-menu') + '"]').parent().remove()
    $('.mobile-menu a[data-drupal-link-system-path="' + $(this).data('remove-from-dropdown-menu') + '"]').parent().remove()
  })

  // mark path to is active
  $('.lab-title-menu .is-active').parents('ul').prev('a').addClass('is-active')

  // search toggle
  $('.search-toggle').on('click', function() {
    $('body').toggleClass('search-overlay--is-showing')
    if ($('body').hasClass('search-overlay--is-showing')) {
      $('.search-overlay input[type="text').focus()
      $('.search-toggle').attr('aria-expanded', 'true')
    } else {
      $('.search-toggle').attr('aria-expanded', 'false')
    }
  })

  // search ajax
  $('.search-overlay form').on('submit', function() {
    var uid = $('.search-overlay form input#owner_id').val()
    var keyword = $('.search-overlay form input#keyword').val()
    var url = '/search/lab/page/' + uid + '/' + keyword
    $.ajax({
      url: url,
      cache: false,
      dataType: 'html'
    }).done(function(html) {
      var resultsHtml = '<ul>'
      var $items = $(html).find('.item-list ul li')
      var totalResults = 0
      $items.each(function() {
        totalResults++
        var $li = $(this)
        var title = $.trim($li.find('.views-field-title').text())
        var alias = $.trim($li.find('.views-field-title a').attr('href'))
        var body = $.trim($li.find('.views-field-body .field-content').html())
        resultsHtml += '<li><p>';
        resultsHtml += '<a href="' + alias + '">' + title + '</a>'
        resultsHtml += '<br>'
        body = body.replace(/\r?\n|\r/g, '')
        var $div = $('<div>' + body + '</div>')
        var $normal = $div.find('p').remove()
        var brief = $normal.text()
        resultsHtml += brief.replace(/(<([^>]+)>)/gi, '')
        resultsHtml += '</p></li>'
      })
      resultsHtml += '</ul>'
      if (totalResults == 0) {
        resultsHtml = '<h3>No results found</h3>'
      }
      $('.search-overlay .search-results').html(resultsHtml)
    }).fail(function(error) {
      var resultsHtml = '<h3>No results found</h3>'
      $('.search-overlay .search-results').html(resultsHtml)
    })
    return false
  })

  // video controls
  if ($('.with-hero-video').length > 0) {
    var mediaElement = document.getElementById('hero-video')
    $('.page-node-type-lab_homepage .video-controls button').on('click', function(e) {
      $('.video-controls').toggleClass('video-controls--is-stopped')
      if ($('.video-controls').hasClass('video-controls--is-stopped')) {
        mediaElement.pause()
      } else {
        mediaElement.play()
      }
      e.preventDefault()
    })
  }

  $('.page-node-type-lab_homepage .toggle-hero-caption').on('click', function(e) {
    $('.page-node-type-lab_homepage .hero-caption').toggleClass('hero-caption--is-showing')
    e.preventDefault()
  }).keypress(function(e) {
    if (e.which == 32 || e.which == 13) {
      $(this).trigger('click');
      e.preventDefault();
    }
  })

  // share url clipboard
  var clipCopy = new ClipboardJS('.clipboard-copy-text', {
    text: function(trigger) {
      return trigger.getAttribute('aria-label')
    }
  })
  clipCopy.on('success', function(e) {
    $('span.link-copied').addClass('link-copied--is-showing')
    setTimeout(function () {
      $('span.link-copied').removeClass('link-copied--is-showing')
    }, 1500)
  })

  // back
  $('a[href="#back"]').on('click', function(e) {
    window.history.back()
    e.preventDefault()
  })

  // paragraph projects - filters
  $('.paragraph--type--projects-simple').each(function() {
    var $paragraph = $(this)
    var $select = $paragraph.find('select')

    var numberOfOptions = $select.children('option').length
    $select.addClass('select-hidden')
    $select.wrap('<div class="select"></div>')
    $select.after('<button class="select-styled" aria-haspopup="true" aria-expanded="false"></button>')

    var $styledSelect = $select.next('button.select-styled')
    $styledSelect.text($select.children('option').eq(0).text())

    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect)

    for (var i = 0; i < numberOfOptions; i++) {
      $('<li />', {
        text: $select.children('option').eq(i).text(),
        rel: $select.children('option').eq(i).val(),
        tabindex: 0
      }).appendTo($list).keypress(function(e) {
        if (e.which == 32 || e.which == 13) {
          $(this).trigger('click');
          e.preventDefault();
        }
      })
      if ($select.children('option').eq(i).is(':selected')) {
        $styledSelect.text($select.children('option').eq(i).text())
      }
    }

    var $listItems = $list.children('li')

    $styledSelect.on('click', function(e) {
      e.stopPropagation()
      e.preventDefault()
      $('button.select-styled.active').not(this).each(function(){
        $(this).removeClass('active').next('ul.select-options').hide()
      })
      $(this).toggleClass('active').next('ul.select-options').toggle()
    })

    $listItems.on('click', function(e) {
      e.stopPropagation()
      $styledSelect.text($(this).text()).removeClass('active')
      $select.val($(this).attr('rel'))
      $list.hide()
      var tid = $select.val()
      $paragraph.find('.cell-project').removeClass('hide')
      if (tid > 0) {
        $paragraph.find('.cell-project').each(function() {
          if ($(this).find('span[data-tid="' + tid + '"]').length == 0) {
            $(this).addClass('hide')
          }
        })
      }
    })

    $select.on('change', function() {
      var tid = $select.val()
      $paragraph.find('.cell-project').removeClass('hide')
      if (tid > 0) {
        $paragraph.find('.cell-project').each(function() {
          if ($(this).find('span[data-tid="' + tid + '"]').length == 0) {
            $(this).addClass('hide')
          }
        })
      }
    })

    $(document).on('click', function() {
      $styledSelect.removeClass('active')
      $list.hide()
    })

  })

  // projects masonry
  $('.paragraph--type--projects-masonry').each(function() {
    var $paragraph = $(this)
    // init Isotope
    var $grid = $paragraph.find('.grid').isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: 30
      }
    })
    // layout Isotope after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout')
    })

    $paragraph.find('.grid-item').on('click', function() {
      var $gridItem = $(this)
      $paragraph.find('.carousel-masonry-project-grid-container').addClass('carousel-masonry-project-grid-container--is-showing')
    })
  })

  // paragraph grid image excerpts - layout type - masonry
  $('.paragraph--type--grid-image-excerpt.paragraph--layout-type-masonry').each(function() {
    var $paragraph = $(this)
    // init Isotope
    var $grid = $paragraph.find('.grid').isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: 30
      }
    })
    // layout Isotope after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout')
    })

  })

  // paragraph publications - pagination
  $('.paragraph--type--publications, .paragraph--type--publications-activity-insights').each(function() {
    var $paragraph = $(this)
    var $pagination = $(this).find('.pagination')
    var $form = $(this).find('form')
    $pagination.find('a').on('click', function(e) {
      var $a = $(this)
      var startIndex = $a.data('page') * 10
      var endIndex = startIndex + 10
      $pagination.find('a').removeClass('active')
      $a.addClass('active')
      $paragraph.find('.publication-item').addClass('hide')
      $paragraph.find('.publication-item').slice(startIndex, endIndex).removeClass('hide')
      var scrollTop = $paragraph.offset().top - 30
      $('html, body').animate({ scrollTop: scrollTop }, 500)
      e.preventDefault()
    })
    // form results
    $form.find('input[type="text"]').on('keyup', function() {
      var keyword = $(this).val().toLowerCase()
      if (keyword) {
        $paragraph.addClass('search--is-active')
        $paragraph.find('.publication-item').addClass('search-hide').removeClass('search-show')
        $paragraph.find('.publication-item').each(function() {
          var $publicationItem = $(this)
          var text = $publicationItem.text().toLowerCase()
          if (text.includes(keyword) == true) {
            $publicationItem.removeClass('search-hide').addClass('search-show')
          }
        })
        // markjs
        $paragraph.find('.publication-item').unmark({
          done: function() {
            $paragraph.find('.publication-item').mark(keyword)
          }
        })
        var totalResults = $paragraph.find('.publication-item.search-show').length
        if (totalResults == 0) {
          $paragraph.find('.results-message').html('No results found.')
        } else if (totalResults == 1) {
          $paragraph.find('.results-message').html('1 result found:')
        } else {
          $paragraph.find('.results-message').html(totalResults + ' results found:')
        }
      } else {
        $paragraph.removeClass('search--is-active')
        $paragraph.find('.publication-item').removeClass('search-hide search-show').unmark()
      }
    }).trigger('keyup')
    $form.on('submit', function() {
      return false
    })
  })

  // paragraphs masonry
  $('.paragraph--type--masonry-project-grid').each(function() {
    var $paragraph = $(this)
    var fitRows = $paragraph.hasClass('masonry-layout-mode-fitrows')
    // init Isotope
    var isotopeSettings = {
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: 30
      }
    }

    if (fitRows) {
      isotopeSettings.layoutMode = 'fitRows'
    }
    var $grid = $paragraph.find('.grid').isotope(isotopeSettings)

    // layout Isotope after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout')
    })

    $paragraph.find('.grid-item').on('click', function() {
      var offset =  1
      if (fitRows) {
        offset = 0
      }
      var $gridItem = $(this)
      $paragraph.find('.carousel-masonry-project-grid-container').addClass('carousel-masonry-project-grid-container--is-showing')
      $carousel.flickity('select', $gridItem.index() - offset)
      $carousel.flickity('resize')
    })

    $paragraph.find('.close, .close-big').on('click', function() {
      $('.carousel-masonry-project-grid-container').removeClass('carousel-masonry-project-grid-container--is-showing')
    })

    var $carousel = $paragraph.find('.carousel-masonry-project-grid').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: false,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true
    })

    $paragraph.find('.next').on('click', function() {
      $carousel.flickity('next')
    })

    $paragraph.find('.previous').on('click', function() {
      $carousel.flickity('previous')
    })
  })

  // paragraph slideshow with carousel thumbnail nav
  $('.paragraph--type--slideshow').each(function() {
    var $paragraph = $(this)
    var $carouselMain = $paragraph.find('.carousel-main').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: false,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fullscreen: false,
      selectedAttraction: 0.1,
      friction: 0.8,
      on: {
        ready: function() {
          var $cell = $paragraph.find('.carousel-main .carousel-cell').eq(0)
          $paragraph.find('.caption-container').html($cell.find('.caption').html())
        },
        select: function() {
          if ($carouselMain) {
            var currentIndex = $carouselMain.data('flickity').selectedIndex
            // update caption
            var $cell = $carouselMain.find('.carousel-cell').eq(currentIndex)
            $paragraph.find('.caption-container').html($cell.find('.caption').html())
          }
        }
      }
    })

    $paragraph.find('.carousel-main-container .next').on('click', function() {
      $carouselMain.flickity('next')
    })

    $paragraph.find('.carousel-main-container .previous').on('click', function() {
      $carouselMain.flickity('previous')
    })

    var $carouselNav = $paragraph.find('.carousel-nav').flickity({
      cellSelector: '.carousel-cell',
      asNavFor: $carouselMain[0],
      setGallerySize: false,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      cellAlign: 'left'
    })

    $paragraph.find('.carousel-nav-container .next').on('click', function() {
      $carouselNav.flickity('next')
    })

    $paragraph.find('.carousel-nav-container .previous').on('click', function() {
      $carouselNav.flickity('previous')
    })

    $carouselNav.find('.carousel-cell').keypress(function(e) {
      if (e.which == 32 || e.which == 13) {
        $carouselMain.flickity('select', $(this).index())
        $carouselNav.flickity('select', $(this).index())
        e.preventDefault();
      }
    })

  })

  // paragraph left text carousel
  $('.paragraph--type--left-text-carousel, .paragraph--type--left-carousel-text').each(function() {
    var $paragraph = $(this)
    var $carousel = $paragraph.find('.carousel-main').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: false,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fullscreen: false,
      on: {
        ready: function() {
          var $cell = $paragraph.find('.carousel-main .carousel-cell').eq(0)
          $paragraph.find('.caption-container-small').html($cell.find('.caption-container').html())
        },
        select: function() {
          if ($carousel) {
            var currentIndex = $carousel.data('flickity').selectedIndex
            // update caption
            var $cell = $carousel.find('.carousel-cell').eq(currentIndex)
            $paragraph.find('.caption-container-small').html($cell.find('.caption-container').html())
          }
        }
      }
    })
    $paragraph.find('.next').on('click', function() {
      $carousel.flickity('next')
    })
    $paragraph.find('.previous').on('click', function() {
      $carousel.flickity('previous')
    })
  })

  // paragraph video
  $('.paragraph--type--video').each(function() {
    var $paragraph = $(this)
    $paragraph.find('video').parent().addClass('responsive-embed widescreen')
  })

  // image container popup
  $('[data-zoom-image]').on('click', function() {
    var $imageContainer = $(this)
    if ($(this).find('a').length == 0) {
      if ($imageContainer.data('zoom-image-url')) {
        var imgSrc = $imageContainer.data('zoom-image-url')
      } else {
        var $img = $(this).find('img')
        var imgSrc = $img.attr('src')
      }
      $('.image-container-large .image').css({
        backgroundImage: 'url("' + imgSrc + '")'
      })
      $('.image-container-large').addClass('image-container-large--is-showing')
    }
  })

  $('.image-container-large').on('click', function() {
    $('.image-container-large').removeClass('image-container-large--is-showing')
  })

  // inline image reveal
  $('figure img[typeof="foaf:Image"]').on('click', function() {
    var $img = $(this)
    var src = $img.attr('src').replace('styles/large/public/', '')
    $('.reveal-inline-image .image').css({
      backgroundImage: 'url(' + src + ')'
    })
    $('.reveal-inline-image').foundation('open')
  })

  $(document).on('click', '.reveal-inline-image .image', function() {
    $('.reveal-inline-image').foundation('close')
  })

  // show body after load
  setTimeout(function() {
    $('body').addClass('is-visible')
  }, 200)

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ($(this).parent().hasClass('has-aspect-ratio') == false) {
      $(this).parent().addClass('responsive-embed widescreen')
    }
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

});
